import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "horizontal-divider"
}
const _hoisted_2 = { class: "card-interactive-footer-content" }
const _hoisted_3 = {
  key: 0,
  class: "card-interactive-footer-controller"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import TextBase, { TextType } from '@/design-system/atoms/TextBase.vue'
import CardBase from './CardBase.vue'
import InfoOverlay from './InfoOverlay.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import CollapseControllerSummary from '../components/CollapseController/CollapseControllerSummary.vue'
import CardInteractiveHeader from './CardInteractiveHeader.vue'
import { useSlots } from 'vue'
import { useWindowWidth } from '@/composables/useWindowWidth'

type Props = {
  title: string
  titleType?: TextType
  titleTypeFullscreen?: TextType
  info?: string
  enableFullscreen?: boolean
  showControls?: boolean
  isLoading?: boolean
  headerDivider?: boolean
}

type Emits = {
  (e: 'toggleFullscreen', fullscreen: boolean): void
  (e: 'toggleShowInfo', showInfo: boolean): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardInteractive',
  props: {
    title: {},
    titleType: { default: 'paragraph' },
    titleTypeFullscreen: { default: 'h4' },
    info: { default: undefined },
    enableFullscreen: { type: Boolean, default: false },
    showControls: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    headerDivider: { type: Boolean, default: false }
  },
  emits: ["toggleFullscreen", "toggleShowInfo"],
  setup(__props: any, { emit: __emit }) {

const slots = useSlots()

const { t } = useI18n()

const props = __props

const emit = __emit

const contentRef = ref<HTMLElement | null>(null)
const contentHeight = computed(() =>
  fullscreen.value ? contentHeightFullscreen.value : contentHeightNormal.value
)
const contentHeightNormal = ref(0)
const contentHeightFullscreen = ref(0)
const showInfo = ref(false)
const fullscreen = ref(false)
const initialRecord = ref(false)
const isLoadingAfterRecord = computed(
  () => props.isLoading !== undefined && initialRecord.value && props.isLoading
)
const windowWidth = useWindowWidth()

const isMobile = computed(() => {
  return windowWidth.value < 768
})

onMounted(() => {
  setTimeout(() => {
    recordContentHeight()
  }, 100)
})

watch(fullscreen, () => {
  setTimeout(() => {
    recordContentHeight()
  }, 100)
})

function recordContentHeight() {
  if (showInfo.value) return
  if (fullscreen.value) {
    contentHeightFullscreen.value = contentRef.value?.clientHeight ?? 0
  } else {
    contentHeightNormal.value = contentRef.value?.clientHeight ?? 0
  }
  initialRecord.value = true
}

function onToggleInfoClick() {
  recordContentHeight()
  showInfo.value = !showInfo.value
  emit('toggleShowInfo', showInfo.value)
}

function onToggleFullscreenClick() {
  recordContentHeight()
  fullscreen.value = !fullscreen.value
  emit('toggleFullscreen', fullscreen.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InfoOverlay, {
      "is-visible": showInfo.value,
      title: _ctx.title,
      info: _ctx.info,
      onClose: _cache[0] || (_cache[0] = () => (showInfo.value = false))
    }, null, 8, ["is-visible", "title", "info"]),
    _createVNode(CardBase, {
      class: _normalizeClass(["card-interactive", { fullscreen: fullscreen.value }]),
      "header-divider": ""
    }, {
      header: _withCtx(() => [
        _createVNode(CardInteractiveHeader, {
          title: _ctx.title,
          titleType: _ctx.titleType,
          titleTypeFullscreen: _ctx.titleTypeFullscreen,
          showInfo: _ctx.info !== undefined,
          showControls: _ctx.showControls,
          enableFullscreen: _ctx.enableFullscreen,
          fullscreen: fullscreen.value,
          onToggleShowInfo: onToggleInfoClick,
          onToggleFullscreen: onToggleFullscreenClick
        }, {
          controls: _withCtx(() => [
            (!isMobile.value)
              ? _renderSlot(_ctx.$slots, "controls", { key: 0 })
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_ctx.headerDivider)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "header")
          ]),
          _: 3
        }, 8, ["title", "titleType", "titleTypeFullscreen", "showInfo", "showControls", "enableFullscreen", "fullscreen"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["card-interactive-footer", fullscreen.value ? 'fullscreen' : ''])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "footer")
          ]),
          (fullscreen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(slots).footerControls)
                  ? _renderSlot(_ctx.$slots, "footerControls", { key: 0 })
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(t)('dashboard__text__selection')) + " : ", 1),
                      _createVNode(CollapseControllerSummary, {
                        showTimeSelection: true,
                        fullscreen: fullscreen.value
                      }, null, 8, ["fullscreen"])
                    ], 64))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      default: _withCtx(() => [
        (isLoadingAfterRecord.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle({ height: `${contentHeight.value}px` }),
              class: "loader-container"
            }, [
              _createVNode(PulseLoader, {
                loading: true,
                color: "#3F46D6"
              })
            ], 4))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              ref_key: "contentRef",
              ref: contentRef,
              class: "content-container"
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 512))
      ]),
      _: 3
    }, 8, ["class"]),
    (fullscreen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlay",
          onClick: onToggleFullscreenClick
        }))
      : _createCommentVNode("", true),
    (fullscreen.value)
      ? (_openBlock(), _createBlock(CardBase, {
          key: 1,
          title: _ctx.title,
          info: _ctx.info,
          class: "placeholder-card"
        }, {
          header: _withCtx(() => [
            _createVNode(CardInteractiveHeader, {
              title: _ctx.title,
              titleType: _ctx.titleType,
              titleTypeFullscreen: _ctx.titleTypeFullscreen,
              showInfo: !!_ctx.info
            }, null, 8, ["title", "titleType", "titleTypeFullscreen", "showInfo"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "placeholder-content",
              style: _normalizeStyle({ height: `${contentHeightNormal.value}px` })
            }, [
              _createVNode(TextBase, {
                text: _unref(t)('dashboard__text-card-showing-in-fullscreen'),
                type: "label",
                color: "secondary"
              }, null, 8, ["text"])
            ], 4)
          ]),
          _: 1
        }, 8, ["title", "info"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})